import { useState, useEffect, useRef } from "react"
import { useLocation, Link } from "react-router-dom"

import { scrollWithOffset } from "../components/scrollWithOffset/index.js"
import TeacherRender from "../components/teacherRender/index.js"
import SecTeacherRender from "../components/secTeacherRender/index.js"
import SubTeacherRender from "../components/subTeacherRender/index.js"

import cleoFabioHome from "../../assets/home_assets/CleoFabioCheers_cleanup.webp"
import boxe from "../../assets/home_assets/boxe 2.webp"
import boxe2 from "../../assets/home_assets/boxe .webp"
import bjjkids from "../../assets/home_assets/Bjj kids.webp"
import fabio from "../../assets/home_assets/fabio.webp"
import jiupersonal from "../../assets/home_assets/jiu personal.webp"
import paiefilha from "../../assets/home_assets/pai e filha.webp"
import fabioaula from "../../assets/home_assets/aula fabio.jpg"
import PC from "../../assets/home_assets/Boxe.jpg"
import CF from "../../assets/home_assets/Jiu Jitsu misto.jpg"
import tctatame from "../../assets/home_assets/TC tatame.jpg"

import beltsInfo from "../../assets/home_assets/beltsInfo.png"
import logo from "../../assets/general_assets/logo-sem-fundo-site.png"
import crezio from "../../assets/home_assets/crezio.png"
import schedule from "../../assets/home_assets/schedule.jpg"

import "./home.css"

export default function Home() {

    const [imgAtual, setImgAtual] = useState(3)

    const imgAtualRef = useRef(null)
    const socials = useRef(null)
    const beltRef = useRef(null)
    const popupref = useRef(null)
    const popupArrowRef = useRef(null)
    const timeoutRef = useRef(null)
    const responsivePopupRef = useRef(null)

    const location = useLocation()

    const imgs = [
        boxe,
        boxe2,
        bjjkids,
        fabio,
        jiupersonal,
        paiefilha
    ]

    const showPopup = () => {

    clearTimeout(timeoutRef.current);

    const currentPopup =
        window.innerWidth <= 768
            ? responsivePopupRef.current
            : popupref.current;

    currentPopup?.classList.remove('closing');
    currentPopup?.classList.add('active');

    const bar = currentPopup?.querySelector('.timer_bar');

    if (bar) {

        bar.style.animation = 'none';

        void bar.offsetWidth;

        bar.style.animation = '';
    }
}

const hidePopup = () => {

    clearTimeout(timeoutRef.current);

    const currentPopup =
        window.innerWidth <= 768
            ? responsivePopupRef.current
            : popupref.current;

    currentPopup?.classList.add('closing');

    const bar = currentPopup?.querySelector('.timer_bar');

    if (bar) {

        bar.style.animation = 'none';

        void bar.offsetWidth;

        bar.style.animation = '';
    }

    timeoutRef.current = setTimeout(() => {

        currentPopup?.classList.remove('active');
        currentPopup?.classList.remove('closing');

    }, 5000);
}

    const eventSize = (e) => {

        if (window.innerWidth > 768) {


            e.preventDefault();
            e.stopPropagation();

            const overlay = document.getElementById('overlay');

            if (beltRef.current && overlay) {
                if (!beltRef.current.classList.contains("expand")) {
                    beltRef.current.classList.add("expand");
                    overlay.classList.add('active');
                } else {
                    beltRef.current.classList.remove("expand");
                    overlay.classList.remove('active');
                }
            }
        } else {
            window.open("/beltsInfo.png", "_blank");
        }

    }

    const reduceEvent = () => {
        const overlay = document.getElementById('overlay');

        if (beltRef.current && overlay) {
            if (beltRef.current.classList.contains("expand")) {
                beltRef.current.classList.remove("expand");
                overlay.classList.remove('active');
            }
        }
    }


    function nextImg() {
        const nextIndex = (imgAtual + 1) % imgs.length
        setImgAtual(nextIndex);

    }

    function prevImg() {
        const prevIndex = (imgAtual - 1 + imgs.length) % imgs.length
        setImgAtual(prevIndex);
    }

    useEffect(() => {
        window.addEventListener("click", reduceEvent);
        window.addEventListener("scroll", reduceEvent);

        return () => {
            window.removeEventListener("click", reduceEvent);
            window.removeEventListener("scroll", reduceEvent);
        }
    }, [])

    useEffect(() => {

        if (location.state?.scrollTo === "academia") {
            const academiaHomeImg = document.getElementById("academiaHomeImg");
            scrollWithOffset(academiaHomeImg, 100)

        } else if (location.state?.scrollTo === "nossaHistoria") {
            const nossaHistoriaHomeImg = document.getElementById("nossaHistoriaHomeImg");
            scrollWithOffset(nossaHistoriaHomeImg, 100)

        }

    }, [location.useState])


    useEffect(() => {

        const autoPopup = () => {

            showPopup();
            hidePopup();
        }

        autoPopup();

        const interval = setInterval(() => {

            autoPopup();

        }, 60*60*1000);

        return () => {

            clearInterval(interval);
            clearTimeout(timeoutRef.current);
        }

    }, []);




    return (
        <>
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"></link>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"></link>
            <main>
                <div id="overlay" className="overlay"></div>
                <span onMouseEnter={showPopup} onMouseLeave={hidePopup} ref={popupref} id="popup">
                    <span onMouseEnter={showPopup} onMouseLeave={hidePopup} style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>
                        <i class="bi bi-exclamation-triangle-fill"></i>
                        <h4>Tolerância Zero</h4>
                        <i class="bi bi-exclamation-triangle-fill"></i>
                    </span>
                    <p>
                        O Team Crezio não aceita e repudia qualquer forma de abuso, assédio ou conduta imprópria,
                        Encorajamos qualquer pessoa que tenha sofrido ou presenciado algum ato dessa natureza a denunciar nos canais oficiais:<br /><br />
                        📞 180 — Central de Atendimento à Mulher<br />
                        📞 100 — Disk Denúncia: Direitos Humanos<br />
                        🚔 Delegacia da Mulher — Procure a mais próxima de você<br />

                    </p>
                    <span className="transformButton">
                        <i ref={popupArrowRef} class="bi bi-caret-right-fill"></i>
                    </span>
                    <div className="timer_bar"></div>
                </span>

                <span onTouchStart={showPopup} onTouchEnd={hidePopup} ref={responsivePopupRef} id="responsivePopup">
                    <span onTouchStart={showPopup} onTouchEnd={hidePopup} style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", gap:"15px" }}>
                        <i class="bi bi-exclamation-triangle-fill"></i>
                        <h4>Tolerância Zero</h4>
                        <i class="bi bi-exclamation-triangle-fill"></i>
                    </span>
                    <p>
                        O Team Crezio não aceita e repudia qualquer forma de abuso, assédio ou conduta imprópria,
                        Encorajamos qualquer pessoa que tenha sofrido ou presenciado algum ato dessa natureza a denunciar nos canais oficiais<br /><br />

                    </p>
                    <div className="timer_bar"></div>
                </span>
                <span ref={socials} className="socials">

                    <Link id="whatsapp" to="https://api.whatsapp.com/send?phone=5524999343720&text=Ol%C3%A1%20gostaria%20de%20marcar%20uma%20aula%20na%20Team%20Crezio!"><i class="bi bi-whatsapp"></i></Link>
                    <Link id="instagram" to="https://www.instagram.com/creziochaveslutas?igsh=NnF0dWEyNWs0NWRx"><i class="bi bi-instagram"></i></Link>
                </span>
                <div id="home_images" className="home_images-container">
                    <img ref={imgAtualRef} className="home_images" src={imgs[imgAtual]} alt="Team Crezio Imagens" loading="lazy"></img>
                    <i onClick={prevImg} id="home-img_left" class="bi bi-arrow-left-circle-fill"></i>
                    <i onClick={nextImg} id="home-img_right" class="bi bi-arrow-right-circle-fill"></i>
                </div>

                <div id="academiaHomeImg" className="general_info">


                    <div className="general_info_content">

                        <h1 className="general_info_title">
                            Bem vindo a Team Crezio
                        </h1>
                        <div className="general_info_text">


                            <div className="general_info_cards">
                                <div className="fundoAbs"></div>

                                <div className="MetCard">
                                    <p>AULAS DINÂMICAS E ADAPTADAS PARA SEU DESENVOLVIMENTO</p>
                                    <img src={fabioaula} alt="imagem" />
                                    <h3>METODOLOGIA COMPROVADA</h3>
                                    <i class="bi bi-clipboard-check"></i>
                                </div>

                                <div className="MetCard">
                                    <p>EQUIPE EXPERIENTE E COMPROMETIDA COM SEU CRESCIMENTO</p>
                                    <img src={PC} ></img>
                                    <h3>PROFESSORES CERTIFICADOS</h3>
                                    <i class="bi bi-mortarboard-fill"></i>
                                </div>
                                <div className="MetCard">
                                    <h3>COMUNIDADE FORTE</h3>
                                    <p>FAÇA PARTE DE UMA FAMÍLIA QUE INCENTIVA SUA EVOLUÇÃO</p>
                                    <img id="imgMenor" src={CF}></img>
                                    <i class="bi bi-people-fill"></i>
                                </div>
                                <div className="MetCard">
                                    <p>DISCIPLINA, CONFIANÇA E CONDICIONAMENTO FÍSICO</p>
                                    <img src={tctatame}></img>
                                    <h3>BENEFÍCIOS ALÉM DO TATAME   </h3>
                                    <i class="fas fa-dumbbell"></i>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div className="belts_info">
                        <img ref={beltRef} onClick={eventSize} src={beltsInfo} />
                    </div>

                </div>

                <div id="nossaHistoriaHomeImg" className="gym_history">
                    <img id="historyLogo" src={logo} />
                    <div className="gym_history_imgs_content">
                    </div>
                    <div className="gym_history_content">

                        <h1 className="gym_history_title">
                            Nossa História
                        </h1>
                        <div className="gym_history_text">

                            <p style={{ fontStyle: "italic", fontWeight: "bold" }}>
                                Mestre Crezio Chaves atualmente com 88 anos de idade e 70 anos deles foram dedicados ao jiu-jitsu.
                            </p>
                            <br />
                            <p>

                                Mestre Crézio Chaves treinou diretamente com grande nomes do Jiu Jitsu como Carlson Gracie, João Alberto Barreto, Hélio Vigio, Robson Gracie entre outros.

                                Hélio e Carlos Gracie viram grande potencial no jovem Crezio Chávez e o incentivaram a lutar Vale Tudo. Ele fez sua estreia aos 17 anos, derrotando seu adversário em apenas 57 segundos do primeiro round.

                                Aos 22 anos Crezio Chávez forma-se instrutor, grau entregue pelas mãos de Carlos e Helio Gracie.

                                Mestre Crezio se aposentou invicto da carreira de lutador, derrotando grandes nomes de sua geração, como Wilson Carmona, Severino de Freitas e Samuel Lancreste.

                                Metre Crezio Chávez se aposentou das lutas como competidor, mas não como professor.

                                Ele continua ministrando aulas na Matriz da Team Crezio em Petrópolis.
                            </p>

                        </div>

                    </div>
                </div>



                <div className="teachers_info">

                    <h1 className="teachers_title"> Equipe Team Crezio</h1>

                    <div className="teachers_list">


                        <TeacherRender />
                        <SecTeacherRender />
                        <SubTeacherRender />


                    </div>
                </div>
            </main>
        </>
    )
}